module.exports = __webpack_public_path__ + "img/barva-zakladni_08_oranzova.6309508a.png";